import React from 'react';
import { Typography, Paper, Box, Button } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import PageBackground from '../components/PageBackground';

const Downloads: React.FC = () => {
  const handleDownload = (filename: string) => {
    // Create the download URL for the file from the public folder
    window.location.href = `/downloads/${filename}`;
  };

  return (
    <PageBackground>
      <Typography variant="h4" gutterBottom sx={{ color: '#333', fontWeight: 600, textShadow: 'none' }}>
        Downloads
      </Typography>
      <Box sx={{ mt: 2 }}>
        <Paper sx={{ 
          p: 3, 
          backgroundColor: '#ffffff', 
          boxShadow: '0 8px 20px rgba(0, 0, 0, 0.06)',
          borderRadius: 2,
          border: '1px solid rgba(240, 240, 240, 0.9)',
        }}>
          <Typography variant="h6" gutterBottom>
            Excel Tools
          </Typography>
          <Typography paragraph>
            Download our Excel Multi-tool with powerful features to enhance your data analysis and processing workflows.
          </Typography>
          <Button 
            variant="contained" 
            startIcon={<DownloadIcon />}
            onClick={() => handleDownload('Excel_Multitool.xlsm')}
            sx={{ 
              mt: 1,
              backgroundColor: '#4caf50',
              '&:hover': {
                backgroundColor: '#45a049',
              }
            }}
          >
            Download Excel Multi-tool
          </Button>
        </Paper>
      </Box>
    </PageBackground>
  );
};

export default Downloads; 